module.exports = __webpack_public_path__ + "static/blablacar-logo.9c6a1f14.svg";